<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12">
          <iq-card>
            <template>
                <b-overlay :show="loader">
                <b-row>
                  <b-col lg="12" sm="12">
                    <b-row style="padding-left:5px">
                        <b-col xs="12" sm="12" md="2" class="text-right" style="margin-left: 82%; margin-top:8px">
                            <!-- <b-button variant="primary" @click="pdfExport">
                                {{  $t('globalTrans.export_pdf') }}
                            </b-button> -->
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('globalTrans.year') }} : {{ getYear(exam.year) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('globalTrans.organization') }} : {{ getOrg(exam.org_id) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark" >{{ $t('ds_institute_management.institute_type') }} : {{ getOfficeTypeList(exam.office_type_id) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark" >{{ $t('educational_management.institute_name') }} : {{ getInstituteName(exam.office_id) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('employee_management.manpower_type') }} : {{ empType(exam.manpower_type) }}</span>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <span class="text-dark">{{ $t('educational_management.date') }} : {{ exam.attendance_date | dateFormat }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="12" sm="12">
                        <div v-if="tmpDataStatus">
                          <b-table-simple striped bordered small>
                              <b-tr class="bg-primary">
                                <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                <th scope="col">{{ $t('ds_institute_management.name') }}</th>
                                <th scope="col">{{ $t('ds_institute_management.designation') }}</th>
                              </b-tr>
                              <b-tr v-for="(item, index) in exam.details" :key="index">
                                <b-td>
                                    {{ $n(index + 1) }}
                                </b-td>
                                <b-td>
                                    {{ (currentLocale == 'bn') ? item.name_bn : item.name }}
                                </b-td>
                                <b-td>
                                    {{ (currentLocale == 'bn') ? item.designation_bn : item.designation }}
                                </b-td>
                              </b-tr>
                          </b-table-simple>
                        </div>

                        <!-- <div v-if="abDataStatus">
                          <b-table-simple striped bordered small>
                              <b-tr class="bg-primary">
                                <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                <th scope="col">{{ $t('ds_institute_management.name') }}</th>
                                <th scope="col">{{ $t('ds_institute_management.designation') }}</th>
                              </b-tr>
                              <b-tr v-for="(item, index) in exam.details" :key="index">
                                <b-td>
                                    {{ $n(index + 1) }}
                                </b-td>
                                <b-td>
                                    {{ (currentLocale == 'bn') ? item.name_bn : item.name }}
                                </b-td>
                                <b-td>
                                    {{ (currentLocale == 'bn') ? item.designation_bn : item.designation }}
                                </b-td>
                              </b-tr>
                          </b-table-simple>
                        </div> -->

                        <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                            </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                </b-overlay>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
// import ExportPdf from './export-routine-detail'
import RestApi, { disabilitySchoolServiceBaseUrl } from '../../../../../config/api_config'
import { getListTeacherStuff } from '../../api/routes'
export default {
  props: ['id'],
  created () {
    if (this.id) {
        const tmp = this.getExamInfoData()
        this.exam = tmp
        this.getEmployeeList()
    }
  },
  data () {
    return {
        loader: false,
        exam: {
            year: 0,
            org_id: 0,
            office_type_id: 0,
            office_id: 0,
            class_id: 0,
            emp_type_id: 0,
            details: [],
            abDetails: []
        },
        tmpDataStatus: 0,
        abDataStatus: 0
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    empTypeData: function () {
      const list = [
        { value: 1, text: this.$i18n.locale === 'en' ? 'Teacher' : 'শিক্ষক' },
        { value: 2, text: this.$i18n.locale === 'en' ? 'Staff' : 'স্টাফ' }
      ]
      return list
    }
  },
  methods: {
    getExamInfoData () {
        const tmpData = this.$store.state.list.find(item => item.id === this.id)
        return JSON.parse(JSON.stringify(tmpData))
    },
    getYear (year) {
        if (this.$i18n.locale === 'bn') {
            return this.$n(year, { useGrouping: false })
        } else {
            return year
        }
    },
    getOrg (orgId) {
        const obj = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text
        }
    },
    getOfficeTypeList (officeType) {
        const obj = this.$store.state.commonObj.officeTypeList.find(item => item.value === officeType)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    getInstituteName (insId) {
      const obj = this.$store.state.commonObj.officeList.find(item => item.value === insId)
        if (this.$i18n.locale === 'bn') {
            return obj.text_bn
        } else {
            return obj.text_en
        }
    },
    empType (empTypeId) {
        const obj = this.empTypeData.find(item => item.value === empTypeId)
        return obj.text
    },
    async getEmployeeList () {
        this.loader = true
        const params = Object.assign({}, { year: this.exam.year, org_id: this.exam.org_id, office_id: this.exam.office_id, office_type_id: this.exam.office_type_id, manpower_type: this.exam.manpower_type })
        await RestApi.getData(disabilitySchoolServiceBaseUrl, getListTeacherStuff, params).then(response => {
            if (response.success) {
                this.exam.details.map(item => {
                    const resItem = response.data.find(res => res.employee_id === item.employee_id)
                    item.name = resItem !== undefined ? resItem.name : ''
                    item.name_bn = resItem !== undefined ? resItem.name_bn : ''
                    item.designation = resItem !== undefined ? resItem.designation : ''
                    item.designation_bn = resItem !== undefined ? resItem.designation_bn : ''
                    return item
                })
                this.tmpDataStatus = 1
                this.abDataStatus = 1
            }
            this.loader = false
        })
    },
    pdfExport () {
        // const reportTitle = this.$t('ds_exam_manangement.exam_schedule')
        // ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, this.exam, this)
    }
  }
}
</script>
